<template>
  <v-dialog v-model="dialog" persistent width="60%">
    <v-btn color="secondary" dark slot="activator">
      {{ $t("screener.revenue_summary.request_payout") }}
    </v-btn>
    <v-card>
      <v-card-title primary-title class="grey lighten-4">
        <div>
          <div class="title">
            {{ $t("screener.revenue_summary.unpaid_amount") }}
          </div>
          <div class="py-1 body-1 greyDarken1--text">
            {{ currency_symbol }} {{ unpaid_revenue }}
          </div>
        </div>
        <v-spacer></v-spacer>
        <v-btn small dark icon color="grey" @click.native="dialog = false">
          <v-icon small>$vuetify.icons.rms_close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text class="mx-0 px-0">
        <v-card-title primary-title>
          <div>
            <div class="title greyDarken1--text">
              {{ $t("screener.revenue_summary.avail_amount_for_payout") }}
            </div>
          </div>
          <v-spacer></v-spacer>
          <div class="py-1 title green--text">
            {{ currency_symbol }} {{ unpaid_revenue }}
          </div>
        </v-card-title>
      </v-card-text>
      <v-card-actions>
        <v-spacer></v-spacer>
        <v-btn color="lightteal" outline @click.native="requestPayout()">{{
          $t("screener.revenue_summary.request_payout")
        }}</v-btn>
        <v-btn color="grey" outline @click.native="dialog = false">{{
          $t("reminder.dialog.box.button.close")
        }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import i18n from "@/i18n";
import rules from "@/validation";
export default {
  name: "RequestPayout",
  props: {
    unpaid_revenue: {
      type: Number,
      default: 0,
    },
    currency_symbol: {
      type: String,
    },
  },
  data() {
    return {
      rules,
      dialog: false,
    };
  },
  computed: {},

  methods: {
    async requestPayout() {
      try {
        await this.$store.dispatch("revenue/requestPayout");
        this.$store.dispatch("app/showMessage", {
          message: i18n.t('screener.revenue_summary.payout_request_success_msg'),
          color: "success",
        });
        this.dialog = false;
        this.$emit('onConfirm');
      } catch (error) {
        this.$store.dispatch("app/showMessage", {
          message: error.message,
          color: "error",
        });
      }
    },
  },
};
</script>
